var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "pages-authentication-code" } }, [
    _c(
      "div",
      { attrs: { id: "pages-authentication-code__container" } },
      [
        _c("div", { attrs: { id: "pages-authentication-code__title" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("authenticationCode.base.title")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "pages-authentication-code__description" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("authenticationCode.base.description")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "pages-authentication-code__tip" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("authenticationCode.base.tip")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("AuthenticationCodeForm", {
          attrs: { onLogin: _vm.login, contactInfo: _vm.contactInfo },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }